import styled, { css } from 'styled-components'
import { Box } from '../../UI/Box'
import { STANDARD_PAGE_MAX_WIDTH, defaultTransition } from '../../../theme'

const cardHoverCss = css`
  cursor: pointer;
  border: 1px solid transparent;

  :hover {
    border: var(--units-1, 1px) solid var(--stroke-secondary, #333);
  }

  ${defaultTransition}
`

export const Card = styled(Box)`
  display: flex;
  ${({ pad }) => !pad && `padding: var(--Spacing-Padding-L, 24px);`}
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: var(--units-8, 8px);
  align-self: stretch;

  background: var(--surface-minimal-primary, rgba(255, 255, 255, 0.04));
  border-radius: 12px;

  p {
    color: var(--text-secondary, #b1b1b1);
    font-family: var(--type-family-space-grotesk, 'Space Grotesk');
    font-size: var(--Text-L-L-size, 16px);
    font-style: normal;
    font-weight: var(--type-weight-Regular, 300);
    line-height: var(--Text-L-L-line-height, 20px); /* 125% */
  }
`

export const DropCardBox = styled(Card) <{ isListPage?: boolean }>`
  min-width: 320px;
  max-width: 320px;
  min-height: 380px;
  justify-content: space-between;
  img.chain-icon {
    max-width: 20px;
  }
  ${({ isListPage }) => {
    if (!isListPage) return
    return css`
      width: 100%;
      min-width: 100%;
      max-width: 100%;
    `
  }}
  ${cardHoverCss}
`

export const DropChapterCardBox = styled(Card)`
  min-width: calc(calc(calc(${STANDARD_PAGE_MAX_WIDTH}px - calc(var(--Index-Grids-Gutters) * 2)) / 3));
  max-width: calc(calc(calc(${STANDARD_PAGE_MAX_WIDTH}px - calc(var(--Index-Grids-Gutters) * 2)) / 3));
  min-height: 432px;
  padding: 16px;
  img {
    width: 100%;
    height: 163px;
    object-fit: cover;
    border-radius: 4px;
  }

  img.reward-img {
    width: 16px;
    height: 16px;
  }
  ${cardHoverCss}
`

export const Divider = styled.div<{ secondary?: boolean }>`
  width: 100%;
  background-color: var(--stroke-tertiary, #191919);
  height: 1px;
  ${({ secondary }) => {
    if (secondary) {
      return `
        background-color: var(--stroke-secondary, #333333);
      `
    }
  }}
`

export const LabsCardBox = styled(Card)`
  min-width: 480px;
  max-width: 480px;
  justify-content: space-between;
  min-height: 540px;
  @media screen and (max-width: ${({ theme }) =>
    theme.breakpoints.medium}px) {
    min-width: 320px;
    max-width: 320px;
    min-height: 460px;
  }
  img.token-logo {
    height: 20px;
    width: 20px;
    border-radius: 50%;
  }

  ${cardHoverCss}
`

export const ImageUploaderCardBox = styled(Card)`
  min-width: 100%;
  max-width: 100%;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;

  img {
    border-radius: var(--units-8, 8px);
    width: auto;
    height: 38px;
  }

  p {
    color: inherit;

    /* Web/Text/L/Semibold */
    font-family: var(--type-family-space-grotesk, 'Space Grotesk');
    font-size: var(--Text-L-L-size, 16px);
    font-style: normal;
    font-weight: var(--type-weight-Semibold, 600);
    line-height: var(--Text-L-L-line-height, 20px); /* 125% */
  }
`

export const TaskCard = styled(Card) <{
  isFaded?: boolean
  isActive?: boolean
  isHighlighted?: boolean
}>`
  min-height: 177px;
  ${({ theme }) => {
    const breakpoints = theme.breakpoints
    const rules = []
    const expandedPlusGutterValue = theme.layout.expandedPlus.indexGrids.gutters
    rules.push(`
        width: calc(33% - ${expandedPlusGutterValue / 2}px);
          min-width: calc(33% - ${expandedPlusGutterValue / 2}px);
          max-width: calc(33% - ${expandedPlusGutterValue / 2}px);
    `)
    for (const key in breakpoints) {
      const gutterValue = theme.layout[key].indexGrids.gutters
      const isExpanded = key === 'expanded'
      rules.push(`
        @media screen and (max-width: ${breakpoints[key]}px) {
          width: calc(${isExpanded ? 33 : 50}% - ${gutterValue / 2}px);
          min-width: calc(${isExpanded ? 33 : 50}% - ${gutterValue / 2}px);
          max-width: calc(${isExpanded ? 33 : 50}% - ${gutterValue / 2}px);
        }
      `)
    }
    return rules.reverse().join('\n')
  }}
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.compact}px) {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
  ${cardHoverCss}
  ${({ isFaded }) => isFaded && `opacity: 0.5;`}
  ${({ isActive }) =>
    isActive &&
    css`
      cursor: pointer;
      ${cardHoverCss}
    `}
  ${({ isHighlighted }) => isHighlighted && `border: 1px solid #FFFF00;`}
`
